<style scoped="scoped" lang="scss">
  .img{
    border: 1px solid #eeefef;
    border-radius: 5px;
  }
</style>

<template>
  <div style="display: inline;">
    <el-card class="box-card" style="margin:10px">
<!--      <div slot="header" class="clearfix">
        <span>子系统</span>
      </div>-->
      <el-row :gutter="20" >
        <el-col :span="6" >
          <div style="text-align:center">
            <img class="img" style="width: 200px; height: 200px;cursor:pointer; " src="@@/assets/img/zhinenggongyi.png"  @click="getUrl('intelligent_process')">
          </div>
        </el-col>
        <el-col :span="6">
<!--          <img  style="width: 200px; height: 200px"
          src="@@/assets/img/zhinenggongyi.png" >-->
        </el-col>
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
      </el-row>
    </el-card>


  </div>
</template>
<script type="text/javascript">

export default {
  name: 'web_child_platform',
  components: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    getUrl(code){
      this.http.get('/custom/open/sso/getUrl?code=' + code).then(res => {
        if(res.data) {
          window.open(res.data, '_blank');
        }
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(()=>{

      })
    },
  }
};
</script>
